/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgAlertsTip24(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M18.373 2A3.627 3.627 0 0122 5.628v12.744A3.628 3.628 0 0118.373 22H5.627A3.628 3.628 0 012 18.372V5.628A3.628 3.628 0 015.627 2h12.746zm2.255 16.372V5.628a2.255 2.255 0 00-2.255-2.255H5.627a2.255 2.255 0 00-2.255 2.255v12.744a2.255 2.255 0 002.255 2.255h12.746a2.255 2.255 0 002.255-2.255zm-8.629-9.804a1.226 1.226 0 100-2.451 1.226 1.226 0 000 2.45zm.638 9.705a.098.098 0 00.098-.098v-8.02a.098.098 0 00-.098-.099h-1.275a.098.098 0 00-.098.098v8.021c0 .055.044.098.098.098h1.275z'
      />
    </svg>
  );
}

export default SvgAlertsTip24;
